"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const useStore_1 = require("../../store/useStore");
const lucide_react_1 = require("lucide-react");
require("./InviteCard.css");
const InviteCard = ({ code }) => {
    const { servers, joinByInvite, setSelectedServer, currentUser } = (0, useStore_1.useStore)();
    const [preview, setPreview] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [joining, setJoining] = (0, react_1.useState)(false);
    const [joined, setJoined] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const fetchPreview = async () => {
            try {
                setLoading(true);
                setError(null);
                const res = await fetch(`${useStore_1.API_BASE_URL}/servers/invite-preview?code=${encodeURIComponent(code)}`, {
                    credentials: 'include',
                });
                if (res.ok) {
                    const data = await res.json();
                    if (isMounted) {
                        setPreview(data);
                        const isAlreadyIn = data.is_member || servers.some((s) => String(s.id) === String(data.id));
                        if (isAlreadyIn) {
                            setJoined(true);
                        }
                    }
                }
                else {
                    const errData = await res.json().catch(() => ({}));
                    if (isMounted)
                        setError(errData.error || 'Davet bağlantısı geçersiz veya süresi dolmuş.');
                }
            }
            catch {
                if (isMounted)
                    setError('Davet bilgisi yüklenemedi.');
            }
            finally {
                if (isMounted)
                    setLoading(false);
            }
        };
        if (code) {
            fetchPreview();
        }
        return () => {
            isMounted = false;
        };
    }, [code, servers]);
    const handleJoin = async (e) => {
        e.stopPropagation();
        if (joined && preview) {
            // Already a member, simply jump to server
            setSelectedServer(preview.id);
            return;
        }
        if (!currentUser) {
            alert('Sunucuya katılmak için önce giriş yapmalısınız.');
            return;
        }
        setJoining(true);
        setError(null);
        try {
            const res = await joinByInvite(code);
            setJoined(true);
            if (res.server_id) {
                setSelectedServer(res.server_id);
            }
        }
        catch (err) {
            setError(err.message || 'Sunucuya katılınamadı.');
        }
        finally {
            setJoining(false);
        }
    };
    if (loading) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-invite-card loading", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-skeleton-avatar" }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-card-skeleton-info", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-skeleton-line short" }), (0, jsx_runtime_1.jsx)("div", { className: "invite-card-skeleton-line title" })] })] }));
    }
    if (error || !preview) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-invite-card error", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-header-label", children: "SUNUCU DAVET\u0130" }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-card-body", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-icon placeholder", children: (0, jsx_runtime_1.jsx)(lucide_react_1.Compass, { size: 24 }) }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-card-details", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-title error-text", children: "Davet Ge\u00E7ersiz" }), (0, jsx_runtime_1.jsx)("div", { className: "invite-card-members", children: error || 'Bu davetin süresi dolmuş olabilir.' })] })] })] }));
    }
    const isMemberOfServer = joined || preview.is_member || servers.some((s) => String(s.id) === String(preview.id));
    const serverIconUrl = preview.icon
        ? preview.icon.startsWith('http')
            ? preview.icon
            : `https://meci.teymensel.com/uploads/${preview.icon}`
        : null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "discord-invite-card", onClick: handleJoin, children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-header-label", children: "B\u0130R SUNUCUYA KATILMA DAVET\u0130 ALDIN" }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-card-body", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-icon", children: serverIconUrl ? ((0, jsx_runtime_1.jsx)("img", { src: serverIconUrl, alt: preview.name })) : ((0, jsx_runtime_1.jsx)("span", { className: "invite-card-letter", children: preview.name.charAt(0).toUpperCase() })) }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-card-details", children: [(0, jsx_runtime_1.jsx)("div", { className: "invite-card-title", title: preview.name, children: preview.name }), (0, jsx_runtime_1.jsxs)("div", { className: "invite-card-meta", children: [(0, jsx_runtime_1.jsx)("span", { className: "invite-card-status-dot" }), (0, jsx_runtime_1.jsx)(lucide_react_1.Users, { size: 12, style: { marginRight: '4px' } }), (0, jsx_runtime_1.jsxs)("span", { children: [(preview.member_count || 1).toLocaleString('tr-TR'), " \u00DCye"] })] })] }), (0, jsx_runtime_1.jsx)("div", { className: "invite-card-action", children: isMemberOfServer ? ((0, jsx_runtime_1.jsxs)("button", { className: "invite-card-btn joined", onClick: handleJoin, type: "button", children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Check, { size: 14, style: { marginRight: '4px' } }), "Kat\u0131ld\u0131n"] })) : ((0, jsx_runtime_1.jsx)("button", { className: "invite-card-btn join", onClick: handleJoin, disabled: joining, type: "button", children: joining ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Loader2, { size: 14, className: "animate-spin", style: { marginRight: '4px' } }), "Kat\u0131l\u0131n\u0131yor..."] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Kat\u0131l", (0, jsx_runtime_1.jsx)(lucide_react_1.ArrowRight, { size: 14, style: { marginLeft: '4px' } })] })) })) })] })] }));
};
exports.InviteCard = InviteCard;
